"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var styled_components_1 = __importDefault(require("styled-components"));
var sidebar_style_component_1 = require("./sidebar.style.component");
exports.Link = styled_components_1.default(react_router_dom_1.NavLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 13px 17px;\n  max-height: 27px;\n  overflow: hidden;\n  display: flex;\n  color: ", ";\n  font-size: 18px;\n  height: 23px;\n  text-decoration: none;\n  align-items: center;\n  :last-of-type {\n    margin-top: auto;\n  }\n\n  &.active {\n    background-color: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  svg {\n    width: 28px;\n    height: 23px;\n    padding-right: 10px;\n    fill: ", ";\n    min-width: 28px;\n  }\n"], ["\n  padding: 13px 17px;\n  max-height: 27px;\n  overflow: hidden;\n  display: flex;\n  color: ", ";\n  font-size: 18px;\n  height: 23px;\n  text-decoration: none;\n  align-items: center;\n  :last-of-type {\n    margin-top: auto;\n  }\n\n  &.active {\n    background-color: ", ";\n  }\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  svg {\n    width: 28px;\n    height: 23px;\n    padding-right: 10px;\n    fill: ", ";\n    min-width: 28px;\n  }\n"])), function (_a) {
    var colours = _a.theme.colours;
    return colours.sidebar.text;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.sidebar.navSelected;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.sidebar.navHover;
}, function (_a) {
    var colours = _a.theme.colours;
    return colours.sidebar.text;
});
exports.Link.displayName = 'Link';
var LinkElement = function (_a) {
    var showLabel = _a.showLabel, link = _a.link;
    return (react_1.default.createElement(exports.Link, { "data-test-id": link.testID, to: link.link },
        react_1.default.createElement(link.icon, null),
        react_1.default.createElement(sidebar_style_component_1.LabelWrapper, { show: showLabel }, link.label)));
};
LinkElement.displayName = 'LinkElement';
exports.default = react_1.memo(LinkElement);
var templateObject_1;
